<template>
  <div class="account-manage">
    <common-layout>
      <div slot="header">
        <h3>后台用户管理</h3>
      </div>
      <div slot="container">
        <div class="account-manage.header">
          <el-button type="success" class="account-manage.addBtn" @click="openModal('')">
            新增用户
          </el-button>
          <section>
            <el-input
              placeholder="请输入用户名"
              v-model="searchValue"
              class="input-with-select"
              clearable
              @change="search"
            >
              <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
            <!-- <label style="margin:0 15px;">平台注册：</label>
            <el-select
              style="width: 140px"
              v-model="srelease"
              clearable
              placeholder="全部"
              @change="search"
            >
              <el-option
                v-for="item in sourcerelease"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
          </section>
        </div>
        <div class="account-manage.table">
          <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerStyle">
            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="username" label="用户名" align="center"></el-table-column>
            <el-table-column prop="password" label="登录密码" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.password
                    ? scope.row.password.substring(0, 2) +
                      '****' +
                      scope.row.password.substring(
                        scope.row.password.length - 1,
                        scope.row.password.length
                      )
                    : ''
                }}
              </template>
            </el-table-column>
            <!-- <el-table-column label="注册平台" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.is_market === 2 && scope.row.is_achievement === 2">后台新增</span>
                <span v-if="scope.row.is_market === 1 && scope.row.is_achievement === 2">
                  大市场平台
                </span>
                <span v-if="scope.row.is_market === 2 && scope.row.is_achievement === 1">
                  成果交易平台
                </span>
              </template>
            </el-table-column> -->
            <el-table-column label="职位" align="center">
              <template slot-scope="scope">
                <el-tag>{{ scope.row.position }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="部门" align="center" prop="department"></el-table-column>
            <!-- <el-table-column
              label="职位"
              align="center"
              prop="position"
            ></el-table-column> -->
            <el-table-column label="手机号" align="center" prop="phone"></el-table-column>
            <el-table-column label="创建时间" align="center" prop="register_time"></el-table-column>
            <el-table-column label="备注" align="center" prop="remark"></el-table-column>
            <el-table-column label="操作" align="left">
              <template slot-scope="scope">
                <el-button style="margin-bottom: 5px" size="mini" @click="openModal(scope.row)">
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="deleteUser(scope.row)"
                  v-show="$store.getters.token != scope.row.id"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pagination">
            <div class="grid-content bg-purple-light">
              <el-pagination
                @current-change="handleCurrentChange"
                :hide-on-single-page="true"
                layout="total, prev, pager, next,jumper"
                :total="total"
                :current-page.sync="current_page"
                :page-size="per_page"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </common-layout>
    <!-- 新增用户 -->
    <el-dialog
      title="用户管理"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form :model="form" :rules="formRules" ref="form">
        <el-form-item label="用户名" :label-width="formLabelWidth" prop="username">
          <el-input v-model="form.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth" prop="password">
          <el-input
            type="password"
            v-model="form.password"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth" prop="checkPass">
          <el-input
            type="password"
            v-model="form.checkPass"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属部门" :label-width="formLabelWidth" prop="department">
              <el-input type="text" v-model="form.department" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职位" :label-width="formLabelWidth" prop="position">
              <el-input type="text" v-model="form.position" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
              <el-input type="phone" v-model="form.phone" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色名" :label-width="formLabelWidth" prop="role_id">
              <el-select v-model="form.role_id" placeholder="请选择" style="width: 100%">
                <el-option
                  v-for="item in roleOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户类型" :label-width="formLabelWidth" prop="type">
              <el-select
                v-model="form.type"
                placeholder="请选择"
                style="width: 100%"
                @change="typeChange"
              >
                <el-option
                  v-for="(item, index) in typeOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.type !== 2 && form.type != 1">
            <el-form-item
              label="关联机构"
              :label-width="formLabelWidth"
              prop="managerId"
              v-if="form.type != 7"
            >
              <el-select
                v-model="form.managerId"
                v-if="form.type != 8"
                filterable
                clearable
                remote
                :remote-method="getAllInvestmentFirms"
                placeholder="请填写机构名称"
                :popper-append-to-body="false"
                @change="detailInfo"
                style="width: 100%;text-align: left;"
              >
                <el-option
                  v-for="item in investmentFirms"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="form.managerName"
                v-if="form.type === 8"
                placeholder="请选择查新机构"
                style="width: 100%"
              >
                <el-option label="中科院上海分院" value="中科院上海分院" />
                <el-option label="上海浦东智产" value="上海浦东智产" />
              </el-select>
            </el-form-item>
            <el-form-item
              label="区域权限"
              :label-width="formLabelWidth"
              prop="type"
              v-if="form.type == 7"
            >
              <el-select
                v-model="form.perm_region"
                placeholder="请选择区域"
                style="width: 100%"
                @change="regionChange"
              >
                <el-option
                  v-for="(item, index) in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="审批权限" :label-width="formLabelWidth" prop="roles">
            <el-cascader
              v-model="form.roles"
              :options="options"
              :props="{ multiple: true, value: 'id', label: 'name' }"
              style="width: 100%"
              clearable
              @change="changeRole"
            ></el-cascader>
          </el-form-item>
        </el-row>
        <el-row v-show="visible">
          <el-form-item label="合同审批级别" :label-width="formLabelWidth" prop="roles">
            <el-select v-model="form.perm_level" style="width: 100%" clearable>
              <el-option
                v-for="item in options1"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
          <el-input type="textarea" :rows="3" v-model="form.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createdUser">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from '../../components/common-layout.vue';
import urlConfig from '../../url';
import '../../libs/formatDate';
export default {
  components: {
    CommonLayout
  },
  data() {
    //------------密码验证-----------
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空'));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的手机号'));
        }
      }
    };

    return {
      visible: false,
      operationType: 'add',
      searchValue: '',
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE'
      },
      srelease: '',
      sourcerelease: [
        {
          value: 1,
          label: '后台新增'
        },
        {
          value: 2,
          label: '大市场平台'
        },
        {
          value: 3,
          label: '成果交易平台'
        }
      ],
      total: 20,
      current_page: 1,
      per_page: 10,
      tableData: [],
      dialogFormVisible: false, //用户新增/编辑
      formLabelWidth: '100px',
      roleOptions: [],
      options: [
        {
          id: 1,
          name: '转移转化平台',
          children: [
            {
              id: 3,
              name: '科技成果'
            },
            {
              id: 4,
              name: '技术需求'
            },
            {
              id: 7,
              name: '业务办理',
              children: [
                {
                  id: 8,
                  name: '技术合同认定'
                }
              ]
            }
          ]
        },
        {
          id: 2,
          name: '军民融合',
          children: [
            {
              id: 5,
              name: '科技成果'
            },
            {
              id: 6,
              name: '技术需求'
            }
          ]
        }
      ],
      options1: [
        {
          id: 1,
          name: '一级权限'
        },
        {
          id: 2,
          name: '二级权限'
        },
        {
          id: 3,
          name: '初审权限'
        },
        {
          id: 4,
          name: '终审权限'
        },
        {
          id: 5,
          name: '大市场签字'
        },
        {
          id: 6,
          name: '科技厅签字'
        }
      ],
      options2: [
        { id: 0, name: '一级大市场' },
        { id: 1, name: '二级科技厅' }
      ],
      form: {
        department: '', //部门
        password: '', //密码
        checkPass: '', //确认密码
        phone: '', //手机号
        position: '', //职位
        register_time: '', //创建时间
        remark: '', //备注
        role_id: '', //角色id
        username: '', //用户名
        type: 2,
        id: '',
        roles: [],
        perm_level: '',
        managerId: '', // 关联金融/投资/担保机构
        managerName: '', // 关联金融/投资/担保机构名称
        perm_region: '' //区域权限
      },
      areaList: [
        {
          name: '兰州市',
          id: '001'
        },
        {
          name: '嘉峪关市',
          id: '002'
        },
        {
          name: '金昌市',
          id: '003'
        },
        {
          name: '白银市',
          id: '004'
        },
        {
          name: '天水市',
          id: '005'
        },
        {
          name: '武威市',
          id: '006'
        },
        {
          name: '张掖市',
          id: '007'
        },
        {
          name: '酒泉市',
          id: '008'
        },
        {
          name: '平凉市',
          id: '009'
        },
        {
          name: '庆阳市',
          id: '010'
        },
        {
          name: '定西市',
          id: '011'
        },
        {
          name: '陇南市',
          id: '012'
        },
        {
          name: '临夏回族自治州',
          id: '013'
        },
        {
          name: '甘南藏族自治州',
          id: '014'
        }
      ],
      formRules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        checkPass: [
          {
            required: true,
            validator: validatePass2,
            trigger: 'blur'
          }
        ],
        department: [
          {
            required: true,
            message: '请输入部门名称',
            trigger: 'blur'
          }
        ],
        position: [
          {
            required: true,
            message: '请输入职位名称',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            validator: validatePhone,
            trigger: 'blur',
            required: true
          }
        ],
        role_id: [
          {
            required: true,
            message: '请选择角色',
            trigger: 'change'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择用户类型',
            trigger: 'change'
          }
        ]
      },
      typeOptions: [
        {
          label: '普通用户',
          value: 1
        },
        {
          label: '管理员',
          value: 2
        },
        {
          label: '城市管理员',
          value: 7
        },
        {
          label: '金融机构',
          value: 3,
          type: 2
        },
        {
          label: '投资机构',
          value: 4,
          type: 1
        },
        {
          label: '担保机构',
          value: 5,
          type: 3
        },
        {
          label: '收劵机构',
          value: 6,
          type: 4
        },
        {
          label: '查新机构',
          value: 8
        }
      ],
      investmentFirms: [],
      dataType: null
    };
  },
  methods: {
    changeRole() {
      this.visible = false;
      if (this.form.roles && this.form.roles.length) {
        this.form.roles.forEach(item => {
          if (item.length == 3) {
            this.visible = true;
            return;
          }
        });
      }
    },
    getTree() {
      /*this.http.get('User').then(res => {
        if (res.code == 0) {
          this.options = res.data.checker_module;
          this.options1 = res.data.perm_levels;
        }
      });*/
    },
    //选择页码
    handleCurrentChange(e) {
      this.current_page = e;
      this.getData(`User?page=${this.current_page}`);
    },
    //创建用户
    createdUser() {
      this.$refs.form.validate(valid => {
        let ids = [];
        this.form.roles.forEach(item => {
          ids.push(item[1]);
        });
        let params = {
          department: this.form.department,
          password: this.form.password,
          phone: this.form.phone,
          position: this.form.position,
          register_time: new Date().format('yyyy-MM-dd hh:mm:ss'),
          remark: this.form.remark,
          role_id: this.form.role_id,
          type: this.form.type,
          username: this.form.username,
          is_checker: this.form.roles.length ? 1 : 0,
          checker_module_id: ids.join(','),
          checker_module_json: JSON.stringify(this.form.roles),
          perm_level: this.visible ? (this.form.perm_level ? this.form.perm_level : 0) : 0,
          manager_id: this.form.managerId,
          manager_name: this.form.managerName,
          perm_region: this.form.perm_region
        };
        if (valid) {
          if (this.operationType == 'add') {
            // params.is_market = 2;
            // params.is_achievement = 2;
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/user/create`, params).then(res => {
              if (res.code == 0) {
                this.$message.success('新建成功！');
                this.getData('User');
                this.dialogFormVisible = false;
              } else {
                this.$message.error(res.status);
              }
            });
          } else {
            delete params.register_time;
            this.http.put(`${urlConfig.devUrl}apij2/admin-api/system/user/` + this.form.id, params).then(res => {
              if (res.code == 0) {
                this.dialogFormVisible = false;
                if (this.$store.getters.token == this.form.id) {
                  this.$alert('当前账户信息变更成功，请重新登录', '提示', {
                    confirmButtonText: '确定',
                    showClose: false,
                    callback: action => {
                      this.$store.dispatch('logout', this.$store.getters.token).then(res => {
                        this.$router.replace('/login');
                      });
                    }
                  });
                } else {
                  this.$message.success('编辑成功！');
                  this.getData('User');
                  this.dialogFormVisible = false;
                }
              } else {
                this.$message.error(res.status);
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 删除用户
    deleteUser(row) {
      this.$confirm('确定删除该用户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.http.request(`${urlConfig.devUrl}apij2/admin-api/system/user/del?id=` + row.id, '', 'delete').then(
            response => {
              if (response.code == 0) {
                this.$message.success('删除成功！');
                this.getData('User');
              } else {
                this.$message.error(response.status);
              }
            },
            error => {}
          );
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    //打开创建用户modal
    openModal(row) {
      this.dialogFormVisible = true;
      this.operationType = row ? 'edit' : 'add';
      this.resetForm();
      this.getAllRole();
      if (row) {
        this.http.get(`${urlConfig.devUrl}apij2/admin-api/system/user/` + row.id).then(res => {
          this.form.department = res.data.department;
          this.form.password = res.data.password; //密码
          this.form.checkPass = res.data.password; //确认密码
          (this.form.phone = res.data.phone), //手机号
            (this.form.position = res.data.position); //职位
          this.form.remark = res.data.remark; //备注
          this.form.role_id = res.data.role_id; //角色id
          this.form.username = res.data.username; //用户名
          this.form.id = res.data.id;
          this.form.roles = JSON.parse(res.data.checker_module_json);
          this.form.perm_level = res.data.perm_level ? res.data.perm_level : '';
          this.form.type = res.data.type;
          this.form.perm_region = res.data.perm_region;
          const item = this.typeOptions.find(item => item.value === this.form.type);
          if (item) {
            this.dataType = item.type;
          }
          if (res.data.manager_id) {
            this.form.managerId = res.data.manager_id;
            this.form.managerName = res.data.manager_name;
            this.investmentFirms = [
              {
                label: res.data.manager_name,
                value: res.data.manager_id
              }
            ];
          }
          this.changeRole();
        });
      }
    },
    resetForm() {
      this.form.department = '';
      this.form.password = ''; //密码
      this.form.checkPass = ''; //确认密码
      this.form.phone = ''; //手机号
      this.form.position = ''; //职位
      this.form.remark = ''; //备注
      this.form.role_id = ''; //角色id
      this.form.username = ''; //用户名
      this.form.id = '';
      this.form.roles = [];
      this.form.perm_level = '';
      this.form.type = 2;
      this.form.managerId = ''; // 关联金融/投资/担保机构
      this.form.managerName = ''; // 关联金融/投资/担保机构名称
      this.form.perm_region = '';
      this.investmentFirms = [];
    },
    //获取数据
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/user/page`, params).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.current_page = res.data.current_page;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
        }
      });
    },
    //获取所有角色
    getAllRole() {
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/admin-role/page`, {
        pageSize: 100,
        isShow: 1
      }).then(res => {
        if (res.code == 0) {
          this.roleOptions = res.data.data || [];
        }
      });
    },
    search() {
      this.getData(`User?username=${this.searchValue}`);
    },
    typeChange(value) {
      this.form.managerId = null;
      this.form.managerName = null;
      this.investmentFirms = [];
      const item = this.typeOptions.find(item => item.value === value);
      if (item) {
        this.dataType = item.type;
      }
    },
    regionChange(value) {},
    getAllInvestmentFirms(item) {
      if (this.dataType === 4) {
        this.http
          .get(
            `${this.urlConfig.devUrl}apij2/admin-api/innovation/introduction/getList?keyword=${item}`
          )
          .then(res => {
            if (res.code == 0) {
              this.investmentFirms = res.data.map(item => {
                return {
                  label: item.name,
                  value: item.id
                };
              });
            }
          });
      } else {
        this.http
          .post(`${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/getList`, {
            keyword: item,
            is_page: 1,
            dataType: this.dataType
          })
          .then(res => {
            if (res.code == 0) {
              this.investmentFirms = res.data.map(item => {
                return {
                  label: item.orgName,
                  value: item.id
                };
              });
            }
          });
      }
    },
    detailInfo(value) {
      const item = this.investmentFirms.find(item => item.value === value);
      this.form.managerName = item.label;
      this.form.managerId = item.value;
    }
  },
  created() {
    this.getData(`User`);
    this.getTree();
  }
};
</script>
<style lang="scss">
@include component(account-manage) {
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }
  }

  @include part(addBtn) {
    margin-right: 30px !important;
    background: #623aa2 !important;
    color: #fff;
    border: none;
    outline: none;
  }

  @include part(table) {
    margin-top: 30px;
  }
}
</style>
